module.exports = __webpack_public_path__ + "img/oosaka_2.3df8eb36.jpg";